// extracted by mini-css-extract-plugin
export default {"wrapper":"LabsProfiles_wrapper__RGXZq"};